import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch } from '../../statistics/statistics.action';

import { Card, Icon, Table } from 'antd';
import TableColumns from '../../../../utils/table-coaches-columns';
import moment from 'moment';
import Modal from '../../../components/modal/modal';

import './coache-info.css';
import { STATUS } from '../../../../utils/constants';

class CoachesInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: []
    }
  }

  componentDidMount() {
    this.props.AsyncAllInfos();
    this.setState({
      dataSource: this.props.statistics.coachesInfoArray
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statistics.coachesInfoArray) {
      this.setState({ dataSource: nextProps.statistics.coachesInfoArray })
    }
  }

  render() {
    let { coachesInfoArray, syncronizing, searchInput } = this.props.statistics;
    const { isOpen, onClose,index} = this.props;

    const data = coachesInfoArray[index];

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={'Detalhes do Coach'}>
            <section className='coachesInfo'>
                { data && 
                    <div className='coachesInfo-container'>

                        <ul className='coachesInfo-default'>
                            <li>
                                <small> Nome: </small>
                                <p> {data.name}  </p>
                            </li>

                            <li>
                                <small> E-mail: </small>
                                <p> {data.email} </p>
                            </li>

                            <li>
                                <small> Telefone Principal: </small>
                                <p> { data.phone || "-" } </p>
                            </li>

                            <li>
                                <small> Telefones Adicionais: </small>
                                <p> { data.phones && Array.isArray(data.phones) ? data.phones.join(', ') : '-' } </p>
                            </li>

                            <li>
                                <small>Status:</small>
                                <p className={`dlg_status_${data.status}`}> {STATUS[data.status]} </p> 
                            </li>

                            <li>
                                <small> Coupon: </small>
                                <p> {data.coupon === null ? 'Sem cupom' : data.coupon} </p>
                            </li>
                       
                            <li>
                                <small> Sessões Realizadas: </small>
                                <p> {data.sessions} </p>
                            </li>

                            <li>
                                <small> Total de Coachees: </small>
                                <p> {data.total_coachees} </p>
                            </li>

                            <li>
                                <small> Total de Horas de Coaching: </small>
                                <p> {data.total_coaching_hours} </p>
                            </li>

                            <li>
                                <small> Ciclos Finalizados: </small>
                                <p> {data.complete_cycles} </p>
                            </li>

                        </ul>

                    </div>
                }
            </section>
        </Modal>
    );
  }
}

const mapStateToProps = state => ({
  statistics: state.statistics
});

const mapDispatchToProps = dispatch => bindActionCreators({ setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CoachesInfo);



// WEBPACK FOOTER //
// ./src/App/containers/coaches/coache-info/coaches-info.js